module.exports = __webpack_public_path__ + "img/img01.e025c517.png";